import createModalModel from './lib/create_modal_model';

export default createModalModel({
  modelName: 'ReopenConversation',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/reopen_conversation.js